export enum TableMode {
  create,
  edit,
  remove,
  clone,
  none,
}
